import { FC } from "react";
import { Box, Flex } from "@radix-ui/themes";

interface SlideIndicatorsProps {
  slides: any[];
  activeIndex: number;
  goToSlide: (index: number) => void;
}

export const SlideIndicators: FC<SlideIndicatorsProps> = ({
  slides,
  activeIndex,
  goToSlide,
}) => {
  return (
    <Flex
      position="absolute"
      inset="auto 0 0 0"
      justify="center"
      gap="2"
      style={{
        zIndex: 1001,
      }}
    >
      {slides.map((_, index) => (
        <Box
          key={index}
          onClick={() => goToSlide(index)}
          width="0.75rem"
          height="0.75rem"
          style={{
            borderRadius: "50%",
            backgroundColor:
              index === activeIndex ? "white" : "rgba(255, 255, 255, 0.5)",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
        />
      ))}
    </Flex>
  );
};
